import { useAuth } from '../contexts/auth-context'
import { useNativeShell } from '../hooks/use-native-shell'
import { useAndroidBackButtonRoot } from '../hooks/use-android-back-button'
import { usePushNotifications } from '../hooks/use-push-notifications'
import { useIosVoipPush } from '../hooks/use-ios-voip-push'
import { AndroidUpdateGate } from './android-update-gate'
import { AppLockScreen } from '../features/security/components/app-lock-screen'
import { WebMfaChallengeScreen } from '../features/security/components/web-mfa-challenge-screen'
import { PendingDeviceApprovalBanner } from '../features/devices/components/pending-device-approval-banner'
import { useDeviceRegistry } from '../features/devices/hooks/use-device-registry'
import { useCarSessionsBridge } from '../features/sessions/hooks/use-car-sessions-bridge'
import { useCarMessagesBridge } from '../features/messages/hooks/use-car-messages-bridge'
import { SessionPushBanner } from '../features/sessions/components/session-push-banner'

/**
 * App shell bootstrap: native status bar / push / biometric soft-lock, plus
 * web weekly MFA gate and device registry (Manage devices includes browsers).
 */
export function NativeBootstrap() {
  const { user } = useAuth()
  useNativeShell()
  useAndroidBackButtonRoot()
  usePushNotifications(user?.userId)
  useIosVoipPush(user?.userId)
  useDeviceRegistry()
  // Android Auto sessions (tap → navigate): provider-gated snapshot push
  // + voice-note queue init.
  useCarSessionsBridge()
  // Android Auto Messages tab: boot snapshot + debounced re-push on every
  // incoming-message event while the app runs.
  useCarMessagesBridge()
  return (
    <>
      <AndroidUpdateGate />
      <PendingDeviceApprovalBanner />
      <AppLockScreen />
      <WebMfaChallengeScreen />
      <SessionPushBanner />
    </>
  )
}
